import { render, staticRenderFns } from "./qiaoliangxiangqing.vue?vue&type=template&id=2e08ee93&scoped=true&"
import script from "./qiaoliangxiangqing.vue?vue&type=script&lang=js&"
export * from "./qiaoliangxiangqing.vue?vue&type=script&lang=js&"
import style0 from "./qiaoliangxiangqing.vue?vue&type=style&index=0&id=2e08ee93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e08ee93",
  null
  
)

export default component.exports